define('models/queueAdmin/Member',[
    'lib/knockout',
    'util/ObservableModel',
    //no references
    'extensions/knockout.validation.extender'
], function (ko, ObservableModel) {
    'use strict';


    /**
     * id: string
     * joined: boolean
     * name: string
     * selfUri: string
     */
    return ObservableModel.extend({
        defaults: {
            name: null
        }
    }, function () {
        var self = this;

        self.unwrap = function () {
            return ObservableModel.unwrap(self, [
                "errors",
                "isAnyMessageShown",
                "isValid",
                "unwrap"
            ]);
        };
    });
});

